export const dateFormatsMapping = {
    '1': 'MM/DD/YYYY',
    '2': 'DD/MM/YYYY',
    '3': 'YYYY/MM/DD',
    '4': 'MMM DD, YYYY',
    '5': 'MMMM DD, YYYY',
};

export const INTAKE_FORM_STATUS = {
    CREATED: 0,
    IN_PROGRESS: 1,
    SUBMITTED: 2,
};

export const INTAKE_FORM_STATUS_COSMOLEX_APP = {
    NOT_SET: 0,
    CREATING: 1,
    CREATED: 2,
    IN_PROGRESS: 3,
    SUBMITTED: 4,
    CLOSED: 5,
    FAILED_CREATION: 6,
    SHARED: 7,
    PROCESSED: 8,
};
